import React from "react";
import PropTypes from "prop-types";

function MoreInfoContent({ result, labels }) {
  if (!result) {
    return null;
  }

  const {
    study,
    mapped_traits: mappedTraits,
    initial_sample_size: initialSampleSize,
    replication_sample_size: replicationSampleSize,
  } = result;

  return (
    <div>
      <h4>{study}</h4>
      <div className="tw-mt-4">
        <table className="varsome-table">
          <tbody>
            {mappedTraits && (
              <tr>
                <td width="25%">
                  <span className="tw-font-bold">{labels.mappedTraits}</span>
                </td>
                <td width="75%">
                  {mappedTraits.map((tr) => (
                    <a
                      key={tr}
                      href={`https://varsome.com/search-results/${tr}`}
                      target="_blank"
                    >
                      {tr}
                    </a>
                  ))}
                </td>
              </tr>
            )}
            {initialSampleSize && (
              <tr>
                <td>
                  <span className="tw-font-bold">
                    {labels.initialSampleSize}
                  </span>
                </td>
                <td>{initialSampleSize}</td>
              </tr>
            )}
            {replicationSampleSize && (
              <tr>
                <td>
                  <span className="tw-font-bold">
                    {labels.replicationSampleSize}
                  </span>
                </td>
                <td>{replicationSampleSize}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

MoreInfoContent.propTypes = {
  labels: PropTypes.shape({
    replicationSampleSize: PropTypes.string,
    initialSampleSize: PropTypes.string,
    mappedTraits: PropTypes.string,
  }),
  result: PropTypes.shape({
    study: PropTypes.string,
    mapped_traits: PropTypes.arrayOf(PropTypes.string),
    initial_sample_size: PropTypes.string,
    replication_sample_size: PropTypes.string,
  }),
};

MoreInfoContent.defaultProps = {
  labels: {},
  result: null,
};

export default MoreInfoContent;
